import { ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useMainToolbar } from '../contexts/MainToolbarContext'

export const useDynamicMainToolbar = (content: ReactNode, dependencies: any[] = []) => {
    const { setToolbarContent } = useMainToolbar()
    const location = useLocation()

    useEffect(() => {
        setToolbarContent(content)
    }, [
        location.pathname,
        setToolbarContent,
        ...dependencies
    ])

    useEffect(() => {
        return () => {
            setToolbarContent(null)
        }
    }, [])
};